// extracted by mini-css-extract-plugin
export default {"root":"BackToTop-module__[local]___wcpDw","bounce-in":"BackToTop-module__[local]___sVcXw"};